<template>
  <div>
    <HeadersDetalhesResumo
      :apelido="imovel.apelido"
      :proprietario="imovel.proprietario"
      :tipo="imovel.tipo"
      :savoynet="imovel.savoynet"
    >
    </HeadersDetalhesResumo>
    <v-layout row wrap align-center class="secondary white--text detalhes-header">
      <v-flex xs2>
        <v-container fluid class="py-2">      
          <v-layout row wrap>
            <v-flex xs12 class="text-xs-left">
              <v-btn icon :to="({ name: 'ImoveisDetalhesResumo', params: { id: $route.params.id } })" class="ma-0 white--text">
                <v-icon>close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
      <v-flex xs8>
        <v-container fluid class="py-2">      
          <v-layout row wrap>
            <v-flex xs12>
              <span class="subtitulo">IPTU / impostos / taxas</span>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
    <template v-if="taxas.length > 0">
      <v-card flat v-for="(item, index) in taxas" :key="item.id">
        <v-layout row wrap class="pt-2">
          <v-flex xs12 sm10 offset-sm1 md8 offset-md2>
            <v-card-text>
              <div class="mb-1"><strong>{{ item.taxa }}:</strong> {{ item.numero }}</div>
              <div class="mb-1" v-if="item.situacao"><strong>Situação:</strong> {{ item.situacao }}</div>
              <div class="mb-1" v-if="item.situacao === 'Pendente ajuizado' && item.ajuizado_cliente"><strong>Cliente/caso:</strong> {{ item.ajuizado_cliente }}</div>
              <div class="mb-1" v-if="item.situacao === 'Pendente ajuizado' && item.ajuizado_processo"><strong>Processo/execução:</strong> {{ item.ajuizado_processo }}</div>
            </v-card-text>
            <v-card-actions class="text-xs-right">
              <v-dialog v-model="dialogEditar" persistent lazy max-width="760" v-if="$hasGranularPermission('taxas', 'edit')">
                <v-btn flat class="text-xs-right primary--text" slot="activator" @click.native="beforeEditar(item)">Editar</v-btn>
                <v-card>
                  <v-card-title>
                    <div class="title">{{ item.taxa }}</div>
                  </v-card-title>
                  <v-card-text>
                    <v-text-field
                      v-model="formEditar.fields.numero"
                      label="Número da taxa/imposto"
                      v-validate="'required'"
                      name="adicionar.numero"
                      data-vv-as="número"
                      :error-messages="errors.has('adicionar.numero') ? errors.first('adicionar.numero') : []"
                    >
                    </v-text-field>
                    <v-select
                        auto
                        v-model="formEditar.fields.situacao"
                        v-bind:items="taxaSituacao"
                        label="Situação"
                      >
                    </v-select>
                    <transition name="slide-x-transition">
                      <div style="width: 100%;" v-if="formEditar.fields.situacao === 'Pendente ajuizado'">
                        <v-text-field
                          v-model="formEditar.fields.ajuizado_cliente"
                          label="Nº do cliente/caso"
                        >
                        </v-text-field>
                        <v-text-field
                          v-model="formEditar.fields.ajuizado_processo"
                          label="Nº do processo/execução"
                        >
                        </v-text-field>
                      </div>
                    </transition>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="error--text" flat @click.native="descartar">Descartar</v-btn>
                    <v-btn class="secondary--text" flat @click.native="onSubmitEditar()">Salvar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog v-model="dialogApagar" lazy max-width="520" v-if="$hasGranularPermission('taxas', 'delete')">
                <v-btn flat class="error--text" slot="activator" @click.native="beforeApagar(item)">Apagar</v-btn>
                <v-card>
                  <v-card-title>
                    <div class="headline">Tem certeza que deseja apagar?</div>
                  </v-card-title>
                  <v-card-text>Essa ação não poderá ser desfeita.</v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="secondary--text" flat @click.native="dialogApagar = false">Descartar</v-btn>
                    <v-btn class="error--text" flat @click.native="onSubmitApagar()">Apagar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-card-actions>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
      </v-card>
    </template>
    <p class="text-xs-center mt-5 subheading" v-else>Nenhuma taxa cadastrada.</p>
    <v-dialog v-model="dialog" persistent lazy max-width="760">
      <v-btn dark fab fixed bottom right class="secondary" slot="activator" v-if="$hasGranularPermission('taxas', 'add')">
        <v-icon>add</v-icon>
      </v-btn>
      <v-card>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 sm6>
              <v-radio v-model="form.fields.selecionarTaxa" label="IPTU" value="IPTU"></v-radio>
            </v-flex>
            <v-flex xs12 sm6>
              <v-radio v-model="form.fields.selecionarTaxa" label="Outra taxa" value="Outra taxa"></v-radio>
            </v-flex>
          </v-layout>
          <v-text-field
            v-if="form.fields.selecionarTaxa !== 'IPTU'"
            v-model="form.fields.taxa"
            label="Nome da taxa/imposto"
            v-validate="'required'"
            name="adicionar.taxa"
            data-vv-as="taxa"
            :error-messages="errors.has('adicionar.taxa') ? errors.first('adicionar.taxa') : []"
          >
          </v-text-field>
          <v-text-field
            v-model="form.fields.numero"
            label="Número da taxa/imposto"
            v-validate="'required'"
            name="adicionar.numero"
            data-vv-as="número"
            :error-messages="errors.has('adicionar.numero') ? errors.first('adicionar.numero') : []"
          >
          </v-text-field>
          <v-select
              auto
              v-model="form.fields.situacao"
              v-bind:items="taxaSituacao"
              label="Situação"
            >
          </v-select>
          <transition name="slide-x-transition">
            <div style="width: 100%;" v-if="form.fields.situacao === 'Pendente ajuizado'">
              <v-text-field
                v-model="form.fields.ajuizado_cliente"
                label="Nº do cliente/caso"
              >
              </v-text-field>
              <v-text-field
                v-model="form.fields.ajuizado_processo"
                label="Nº do processo/execução"
              >
              </v-text-field>
            </div>
          </transition>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="error--text" flat @click.native="descartar">Descartar</v-btn>
          <v-btn class="secondary--text" flat @click.native="onSubmit">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ButtonsObservacoesAnexos class="mt-3"></ButtonsObservacoesAnexos>
  </div>
</template>

<script>
  import _ from 'lodash'
  import axios from 'axios'
  import { apiURL } from '@/config'
  import HeadersDetalhesResumo from '../Headers/HeadersDetalhesResumo'
  import ButtonsObservacoesAnexos from './ButtonsObservacoesAnexos'

  export default {
    components: {
      HeadersDetalhesResumo,
      ButtonsObservacoesAnexos
    },
    data () {
      return {
        dialog: false,
        dialogEditar: false,
        dialogApagar: false,
        imovelId: this.$route.params.id,
        form: {
          fields: {
            selecionarTaxa: 'IPTU',
            taxa: 'IPTU',
            numero: '',
            situacao: '',
            ajuizado_cliente: '',
            ajuizado_processo: ''
          }
        },
        formEditar: {
          fields: {
            numero: '',
            situacao: '',
            ajuizado_cliente: '',
            ajuizado_processo: ''
          }
        },
        itemEditar: {},
        itemApagar: {}
      }
    },
    computed: {
      imovel () {
        return this.$store.getters['imoveis/detalhes']
      },
      canViewTaxas () {
        return this.$hasGranularPermission('taxas', 'view')
      },
      canEditTaxas () {
        return this.$hasGranularPermission('taxas', 'edit')
      },
      taxas () {
        return this.$store.getters['imoveis/taxas']
      },
      taxaSituacao () {
        return this.$store.getters['constants/taxaSituacao']
      },
      isFormInvalid () {
        return Object.keys(this.fields).some(key => this.fields[key].invalid) || _.isEmpty(_.omitBy(this.form.fields, _.isEmpty))
      }
    },
    watch: {
      'form.fields.selecionarTaxa' (value) {
        if (value === 'IPTU') {
          this.form.fields.taxa = 'IPTU'
        } else {
          this.form.fields.taxa = ''
        }
      }
    },
    methods: {
      descartar () {
        this.dialog = false
        this.dialogEditar = false
        this.dialogApagar = false
        this.form.fields.selecionarTaxa = 'IPTU'
        this.form.fields.taxa = ''
        this.form.fields.numero = ''
        this.form.fields.situacao = ''
        this.form.fields.ajuizado_cliente = ''
        this.form.fields.ajuizado_processo = ''
        this.formEditar.fields.numero = ''
        this.formEditar.fields.situacao = ''
        this.formEditar.fields.ajuizado_cliente = ''
        this.formEditar.fields.ajuizado_processo = ''
        this.errors.clear()
      },
      beforeEditar (item) {
        if (!this.canEditTaxas) return
        this.formEditar.fields.numero = item.numero
        this.formEditar.fields.situacao = item.situacao
        this.formEditar.fields.ajuizado_cliente = item.ajuizado_cliente
        this.formEditar.fields.ajuizado_processo = item.ajuizado_processo
        this.itemEditar = item
      },
      beforeApagar (item) {
        this.itemApagar = item
      },
      onSubmit () {
        this.$store.dispatch('utils/showLoading')

        this.$validator.validateAll('adicionar').then((result) => {
          if (result) {
            axios.post(`${apiURL}/taxas/${this.imovelId}`, this.form.fields).then((response) => {
              this.$store.dispatch('imoveis/insertTaxa', response.data.data)
              this.descartar()
              this.$store.dispatch('utils/hideLoading')
            }, () => {
              this.$store.dispatch('utils/showSnackbar', {
                text: 'Servidor indisponível. Tente novamente mais tarde.'
              })
              this.$store.dispatch('utils/hideLoading')
            })
          } else {
            this.$store.dispatch('utils/showSnackbar', {
              type: 'error',
              text: 'Preencha os campos corretamente'
            })
            this.$store.dispatch('utils/hideLoading')
          }
        })
      },
      onSubmitEditar () {
        if (!this.canEditTaxas) return
        this.$store.dispatch('utils/showLoading')

        this.$validator.validateAll('editar').then((result) => {
          if (result) {
            axios.patch(`${apiURL}/taxas/${this.itemEditar.id}`, this.formEditar.fields).then((response) => {
              this.$store.dispatch('imoveis/updateTaxa', { item: this.itemEditar, data: response.data.data })
              this.descartar()
              this.$store.dispatch('utils/hideLoading')
            }, () => {
              this.$store.dispatch('utils/showSnackbar', {
                text: 'Servidor indisponível. Tente novamente mais tarde.'
              })
              this.$store.dispatch('utils/hideLoading')
            })
          } else {
            this.$store.dispatch('utils/showSnackbar', {
              type: 'error',
              text: 'Preencha os campos corretamente'
            })
            this.$store.dispatch('utils/hideLoading')
          }
        })
      },
      onSubmitApagar () {
        axios.delete(`${apiURL}/taxas/${this.itemApagar.id}`).then((response) => {
          this.$store.dispatch('imoveis/deleteTaxa', this.itemApagar)
          this.descartar()
          this.$store.dispatch('utils/hideLoading')
        }, () => {
          this.$store.dispatch('utils/showSnackbar', {
            text: 'Servidor indisponível. Tente novamente mais tarde.'
          })
          this.$store.dispatch('utils/hideLoading')
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// DetalhesTaxas.vue?1eb6d469